import { Deserializable } from '../deserializable';

export class LookupFiaStatus implements Deserializable{

    public id : number;
    public name: string;

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}